import React from 'react'
import { GridLoader} from "react-spinners";

class Loader extends React.Component {
 
    render() {
        return (
             this.props.loading && <div className="sweet-loading" >
              <GridLoader
                    css={{ "display": "block", "margin": "0 auto", "border-color": "#5c6b25" }}
                    size={30}
                    color={"#5c6b25"}
                    loading={this.props.loading}
                />
            </div>
        
        );
    }
}

export default Loader;